'use client'

import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import type { CosmeticProfileEntry } from '@/features/profiles/types/avatar-catalog'
import { api } from '@/shared/services/api'

import { CosmeticRedeemModal } from './CosmeticRedeemModal'

const queryKey = ['user', 'cosmetics', 'profile'] as const

export interface CosmeticRedeemModalScreenProps {
  entry: CosmeticProfileEntry
  onHide?: () => void
}

export function CosmeticRedeemModalScreen({
  entry,
  onHide
}: CosmeticRedeemModalScreenProps) {
  const queryClient = useQueryClient()

  const handleUnlock = useCallback(
    async (
      unlockEntry: CosmeticProfileEntry,
      _options?: { silentGlobalSuccess?: boolean }
    ): Promise<{ ok: boolean; errorMessage?: string }> => {
      try {
        await api.post(`/user/cosmetics/${unlockEntry.id}/unlock`)
        await queryClient.invalidateQueries({ queryKey })
        return { ok: true }
      } catch (e: unknown) {
        const err = e as { response?: { data?: { error?: string } } }
        const msg =
          err.response?.data?.error ??
          'Não foi possível desbloquear. Tente novamente.'
        return { ok: false, errorMessage: msg }
      }
    },
    [queryClient]
  )

  return (
    <CosmeticRedeemModal
      entry={entry}
      onClose={() => onHide?.()}
      onUnlock={handleUnlock}
    />
  )
}
